import React, { useEffect, useState, useRef, useMemo} from 'react';
import {
  BrowserRouter,
  useLocation, useHistory
} from "react-router-dom";
import mixpanel from 'mixpanel-browser';
import axios from 'axios';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import ContactSupportRoundedIcon from '@material-ui/icons/ContactSupportRounded';
import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';
import CloudDoneOutlinedIcon from '@material-ui/icons/CloudDoneOutlined';
import CloudOutlinedIcon from '@material-ui/icons/CloudOutlined';
import MenuBookRoundedIcon from '@material-ui/icons/MenuBookRounded';
import OndemandVideoRoundedIcon from '@material-ui/icons/OndemandVideoRounded';
import CreateRoundedIcon from '@material-ui/icons/CreateRounded';
import LooksOneRoundedIcon from '@material-ui/icons/LooksOneRounded';
import LooksTwoRoundedIcon from '@material-ui/icons/LooksTwoRounded';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import ShareRoundedIcon from '@material-ui/icons/ShareRounded';
import VerifiedUserRoundedIcon from '@material-ui/icons/VerifiedUserRounded';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import FormControl from '@material-ui/core/FormControl';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useDispatch, useSelector } from 'react-redux';
import { Typography,Button, Tooltip, Menu,Popper, MenuItem,ListItem, ListItemIcon, ListItemText, StepContent, Modal, Avatar, TextField, OutlinedInput, Divider, InputAdornment, InputLabel, FormHelperText } from '@material-ui/core';
import { AvatarGroup } from '@material-ui/lab';
import MuiAlert from '@material-ui/lab/Alert';
import {
  selectWorkflowActive, selectWorkflowName, notification, selectActiveEnabled, activeEnabled, selectWorkflowElements, elementUpdated, selectElementById,
  nameUpdated, activeUpdated, saveWorkflow, createTrigger, deleteTrigger
} from '../features/workflow/workflowSlice';
import { canActivateWorkflow, getActivationBlockerMessage } from './helpers/stepReady';
import {
  tokenUpdated
} from '../features/externalState/externalSlice'
import { trackWorkflowActivated, trackWorkflowDeactivated, identifyUser, trackWorkflowActivationBlocked } from '../utils/posthog';

const modalheight = window.innerHeight;
const modalwidth = window.innerWidth;
function getModalStyle() {
  const top = 5
  //const left = 50 + rand();

  return {
      top: `${top}%`,
      margin: 'auto'
    //  left: `${left}%`,
    //  transform: `translate(-${top}%, -${left}%)`,
  };
}

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.default,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.default,
      },
    },
  },
}))(MenuItem);

const GreenSwitch = withStyles({
 
  switchBase: {
    color: '#ffffff',
    '&$checked': {
      color: '#4caf50',
    },
    '&$checked + $track': {
      backgroundColor: '#4caf50',
    },
  },
  checked: {},
  track: {},
})(Switch);

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    paddingBottom: '5px',


  },
  right: {
    flexGrow: 0,
    justifyContent: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '2px',
    marginRight: 0,
  },
  rightActions: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  shareright: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 0,
    marginRight: theme.spacing(1),
  },
  modalshare: {
    position: 'absolute',
    width: '80%',
    height: modalheight * .75,
    backgroundColor: theme.palette.background.paper,
    border: '0px solid #000',
    borderRadius: '4px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: 'scroll'
},
modalsharesuccess: {
  position: 'absolute',
  width: 'auto',
  maxWidth: '600px',
  minWidth: '550px',
  backgroundColor: theme.palette.background.paper,
  border: '0px solid #000',
  borderRadius: '8px',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(3, 4),
  overflowY: 'auto',
  outline: 'none'
},
  title: {
    flexGrow: 1,
  },
  margin: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(4)
  },
  marginSmall: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(2)
  },
  switch: {
    border: '1px solid',
    borderRadius: '40px',
    width: '100px',
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
  },
  switchSmall: {
    backgroundColor: 'gray',
    border: '1px solid',
    borderRadius: '40px',
    width: '100px',
    alignItems: 'center',
    display: 'flex',
    bottom: theme.spacing(4),
    right: theme.spacing(1),
    position: 'fixed',
    marginRight: theme.spacing(2),
    zIndex: 9,
  },
  help: {
    marginLeft: theme.spacing(2),
    float: 'right',
    display: 'flex-end',
    right: 0,
    alignItems: 'center',
    //position: 'absolute',
    marginRight: theme.spacing(2)

  },
  input: {
    padding: '0px 20px 0px 0px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    border: 'none',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontSize: '18px',
    '&:focus': { 
      outline: 'none',
      borderBottom: `2px solid ${theme.palette.primary.main}`
      },
    '&::placeholder': {
      color: theme.palette.text.secondary,
      opacity: 0.6
    }

  },
  helpSmall: {
    marginLeft: theme.spacing(2),
    float: 'right',
    display: 'flex-end',
    right: 0,
    alignItems: 'center',
    //position: 'absolute',
    marginRight: theme.spacing(1)
  },
  avatarlarge: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  undoRedo: {
    marginLeft: theme.spacing(1),
    cursor: 'pointner'
  },
  pulse: {
    animation: '$pulse 1s ease-in-out infinite',
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
      opacity: 1,
    },
    '50%': {
      transform: 'scale(1.1)',
      opacity: 0.7,
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 1,
    },
  },
}));



export const AppBarHeader = ({
  sendLoggedOutToAuthorizer, breakpoint, selectedElement, activationRequestRef
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  // const getactive = useSelector((state) => state.active.active);
  // const existingwf = useSelector((state) => state.existingwf.existingwf);
  
  // const getwfname = useSelector((state) => state.wfname.wfname);
  // const djangoid = useSelector((state) => state.djangoid.djangoid);
  // const tokenid = useSelector((state) => state.tokenid.tokenid);
  
  const [cookie, setCookie] = useState();
  const [modalStyle] = React.useState(getModalStyle);
  const active = useSelector(selectWorkflowActive)
  const active_enabled = useSelector(selectActiveEnabled)
  const name = useSelector(selectWorkflowName)
  const [wfname, setWFName] = useState(name ?? 'Untitled Workflow');
  const [alert, setAlert] = useState({
    "status": "info",
    "message": "Firing up the engines. Please wait..."
});
const [openalert, setOpenAlert] = React.useState(false);


  useEffect(() => {
    if (cookie) {
      const queryParams = new URLSearchParams(location.search)
      queryParams.delete('c')
        history.replace({
          search: queryParams.toString(),
        })
      // Identify user when token is available
      identifyUser(cookie);

    } else {
      const queryParams = new URLSearchParams(location.search)
      if (queryParams.has('c')) {
        const token = query.get("c");
        localStorage.setItem('tok_', token)
        setCookie(token);
        dispatch(tokenUpdated(token))
        // Identify user when token is available
        identifyUser(token);
        queryParams.delete('c')
        history.replace({
          search: queryParams.toString(),
        })
      }
      else {
       const token = localStorage.getItem('tok_')
       setCookie(token);
       dispatch(tokenUpdated(token))
       // Identify user when token is available
       if (token) {
         identifyUser(token);
       }

      }
    }
  }, [cookie])


  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();
  const id = query.get("id")
  const user = query.get("u");
  const tenant = query.get("t");


  const location = useLocation()
  const history = useHistory()


  // useEffect(() => {
  //   if (cookie) {
  //     dispatch(tokenId(cookie))
  //   }
  // }, [cookie])

  

     useEffect(() => {
   }, [active])

   // Handle browser back button and page unload
   useEffect(() => {
     // Check if we should show warning (workflow can be turned on but is OFF)
     const shouldWarn = active_enabled === true && active === false;
     
     const handleBeforeUnload = (e) => {
       // Check flag inside handler to get latest value (in case it changed after useEffect ran)
       const templateAcceptanceInProgress = localStorage.getItem('templateAcceptanceInProgress') === 'true';
       if (shouldWarn && !templateAcceptanceInProgress) {
         // Standard browser confirmation dialog for page close/tab close
         e.preventDefault();
         e.returnValue = ''; // Chrome requires returnValue to be set
         return '';
       }
     };

    const handlePopState = (e) => {
      // User chose "Leave without turning on" and we ran the exit (history.go(-1)); this popstate is the result. Complete the leave without re-opening the modal.
      if (leaveWithoutTurningOnInProgressRef.current) {
        leaveWithoutTurningOnInProgressRef.current = false;
        // Go back again so we actually leave (we had pushed state, so one go(-1) only undoes that)
        if (window.history.length > 1) {
          window.history.go(-1);
        }
        return;
      }
      // Check flag inside handler to get latest value
      const templateAcceptanceInProgress = localStorage.getItem('templateAcceptanceInProgress') === 'true';
      if (shouldWarn && !templateAcceptanceInProgress) {
        // popstate fires after navigation, so push back immediately
        window.history.pushState(null, '', window.location.href);
        // Show our custom modal; store in ref so "Leave without turning on" always has the fn
        const backExitFn = () => {
          if (window.history.length > 1) {
            window.history.go(-1);
          }
        };
        pendingExitActionRef.current = backExitFn;
        setPendingExitAction(() => backExitFn);
        setModalOpenWorkflowOffWarning(true);
      }
    };

     // Add beforeunload listener for page close/tab close
     if (shouldWarn) {
       window.addEventListener('beforeunload', handleBeforeUnload);
     }
     
     // Add popstate listener for browser back button; push state only once so "Leave without turning on" only needs one extra go(-1)
     if (shouldWarn) {
       if (!hasPushedHistoryStateRef.current) {
         window.history.pushState(null, '', window.location.href);
         hasPushedHistoryStateRef.current = true;
       }
       window.addEventListener('popstate', handlePopState);
     } else {
       hasPushedHistoryStateRef.current = false;
     }

     return () => {
       if (shouldWarn) {
         window.removeEventListener('beforeunload', handleBeforeUnload);
         window.removeEventListener('popstate', handlePopState);
       }
     };
   }, [active_enabled, active]) 

   useEffect(() => {
    if (alert) {
        handleClickAlert();
    }
}, [alert])
 //  useEffect(() => {
 //    if (wfname.length > 0) {
 //      setWFName(wfname);
 //    }
 //  }, [wfname])

  // const handleWFSubmit = event => {
  //   event.preventDefault();
  //   dispatch(wfName(wfname))
  //   setWFName('');

  // };

  const handleWFSubmitKeyDown = event => {
    setWFName(null)
    if (event.key === 'Enter') {
      event.preventDefault();
      // dispatch(wfName(wfname))
       setWFName(event.target.value);
      dispatch(nameUpdated(event.target.value))

      event.target.blur();
      dispatch(notification({ "status": "success", "message": "Workflow name updated: "+event.target.value }))
    }

  };

  // const w3 = {
  //   active: !getactive
  // };


  // const w2 = {
  //   name: getwfname
  // };
  const elements = useSelector(selectWorkflowElements)
  const canActivate = React.useMemo(
    () => canActivateWorkflow(Array.isArray(elements) ? elements : []),
    [elements]
  )
  const activationBlockerMessage = React.useMemo(
    () => getActivationBlockerMessage(Array.isArray(elements) ? elements : []),
    [elements]
  )

  const iconsfiltered = React.useMemo(() => {
    const icons = (elements || []).filter(x => x.data).map((item) => item.data?.icon).filter(Boolean)
    return icons
  }, [elements])
  const triggerNode = elements ? elements.filter(x => x.type === 'trigger') : null
  const node = useSelector(selectElementById(triggerNode[0]?.id))
  const [triggerMessage, setTriggerMessage ] = useState(triggerNode[0] && triggerNode[0].data ? triggerNode[0].data.triggerMessage : null)

  useEffect(() => {
    dispatch(activeEnabled(canActivate))
  }, [canActivate, dispatch]) 
 

  // Check if workflow should be turned on before leaving
  const shouldShowWarning = () => {
    // Show warning if workflow can be turned on (active_enabled === true) but is currently OFF
    return active_enabled === true && active === false;
  };

  const handleExitAttempt = (exitFunction) => {
    if (shouldShowWarning()) {
      // Store in ref so click handler always has it (state updates are async)
      pendingExitActionRef.current = exitFunction;
      setPendingExitAction(() => exitFunction);
      setModalOpenWorkflowOffWarning(true);
    } else {
      // No warning needed, proceed with exit
      exitFunction();
    }
  };

  const handleTurnOnAndExit = () => {
    const exitFn = pendingExitActionRef.current || pendingExitAction;
    pendingExitActionRef.current = null;
    setPendingExitAction(null);
    // Turn on the workflow
    if (!active) {
      handleSwitchChange();
    }
    // Close the modal
    setModalOpenWorkflowOffWarning(false);
    // Wait a moment for the switch to process, then exit
    setTimeout(() => {
      if (typeof exitFn === 'function') {
        exitFn();
      }
    }, 500);
  };

  const handleCancelExit = () => {
    leaveWithoutTurningOnInProgressRef.current = false;
    pendingExitActionRef.current = null;
    setModalOpenWorkflowOffWarning(false);
    setPendingExitAction(null);
  };

  const handleLeaveWithoutTurningOn = () => {
    // Read from ref first so we always have the exit fn (state can be stale)
    const exitFn = pendingExitActionRef.current || pendingExitAction;
    const hadExitFn = typeof exitFn === 'function';
    pendingExitActionRef.current = null;
    setPendingExitAction(null);
    setModalOpenWorkflowOffWarning(false);
    // Mark that we're leaving so the next popstate doesn't re-open the modal
    leaveWithoutTurningOnInProgressRef.current = true;
    // Run the stored exit (e.g. history.go(-1) for back button, or redirect for close button)
    if (hadExitFn) {
      try {
        exitFn();
      } catch (err) {
        console.error('Leave without turning on: exit action failed', err);
      }
    }
    // Fallback: if we had no exit fn (e.g. stale closure), try going back so user isn't stuck
    if (!hadExitFn && window.history.length > 1) {
      requestAnimationFrame(() => {
        window.history.go(-1);
      });
    }
  };

  const closeFrame = () => {
    // Intercept and check if we should show warning
    handleExitAttempt(() => {
      // This is the actual exit function
      if (user){
      if (!name){
        dispatch(nameUpdated('Untitled Workflow (Draft)'))
        const icons = elements.filter(x => x.data).map((item) => item.data.icon);
        const icons_filtered = icons.filter(x => x !== undefined);
    var data = {
      "operation": "updateScaffold",
      "data": {
        "name": name,
        "active": active ? active : false,
        "icons": icons_filtered,
        "cookie": cookie,
        "tenant": tenant,
        "id": id
      }
    };
    var config = {
      method: 'post',
      url: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/djangocaller',
      data: data,
      headers: {
        'Content-Type': 'application/json'
      }
    };
    axios(config)
      .then(function (response) {
        window.location.href = "https://automate.workload.co/workflow?authToken="+cookie
      })
      .catch(function (error) {
      });
       
      } else {
        const icons = elements.filter(x => x.data).map((item) => item.data.icon);
        const icons_filtered = icons.filter(x => x !== undefined);
        
    var data2 = {
      "operation": "updateScaffold",
      "data": {
        "name": name,
        "active": active ? active : false,
        "icons": icons_filtered,
        "cookie": cookie,
        "tenant": tenant,
        "id": id
      }
    };
    var config2 = {
      method: 'post',
      url: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/djangocaller',
      data: data2,
      headers: {
        'Content-Type': 'application/json'
      }
    };
    axios(config2)
      .then(function (response) {
        window.location.href = "https://automate.workload.co/workflow?authToken="+cookie;
      })
      .catch(function (error) {
        window.location.href = "https://automate.workload.co/workflow?authToken="+cookie
      });
        
      }
      
    } else {

    // let url =
    //  window.location != window.parent.location
    //    ? document.referrer
    //    : document.location.href;
    //    window.location.href = url;
    window.location.href = "https://automate.workload.co/workflow?authToken="+cookie;
    }
    });
  };

  //const handleDjangoNameUpdate = () => {
  // const workflow = saveWorkflow();
  //  Object.assign(workflow, w2, w3);
  // var data = {
  //  "operation": "updateWorkflow",
  //  "id": djangoid,
  //  "data": workflow
  //};
  /* var config = {
    method: 'post',
    url: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/djangocaller',
    data: data,
    headers: { 
      'Content-Type': 'application/json'
    }
  };
  axios(config)
  .then(function (response) {
    handleScaffoldUpdate()
},)
  .catch(function (error) {
  });
  } */

  const handleScaffoldUpdate = () => {
    scaffoldUpdateWithActive(!active);
  }

  const scaffoldUpdateWithActive = (activeValue) => {
    var data = {
      "operation": "updateScaffold",
      "data": {
        "name": name,
        "active": activeValue,
        "cookie": cookie,
        "tenant": tenant,
        "icons": iconsfiltered,
        "id": id
      }
    };
    var config = {
      method: 'post',
      url: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/djangocaller',
      data: data,
      headers: {
        'Content-Type': 'application/json'
      }
    };
    axios(config)
      .then(function (response) {

      })
      .catch(function (error) {
      });
  }

  const handleSaveClick = () => {
    dispatch(saveWorkflow(1))
}

const saveNode = () => {
  dispatch(elementUpdated(triggerNode.id,
      {...triggerNode, triggerMessage: triggerMessage},
      null
  ));
}

const handleSwitchChange = () => {
  if (!active && !canActivate) {
    try {
      trackWorkflowActivationBlocked(id, ['WIZARD_INCOMPLETE'])
    } catch (_) {}
    const msg = activationBlockerMessage
      ? `Cannot activate: ${activationBlockerMessage}`
      : 'Cannot activate: finish Setup, Configure, and Test for every step first.'
    dispatch(notification({ status: 'warning', message: msg }))
    return
  }
  // CRITICAL FIX: For polling triggers, ensure triggerResource is restored from performList before saving
  // This must happen BEFORE handleSaveClick() to prevent saving empty triggerResource
  if (node && node.data && node.data.type === 'polling' && (!node.data.triggerResource || node.data.triggerResource === '') && node.data?.performList && node.data.performList !== '') {
    // Restore triggerResource from performList before any save operations
    dispatch(elementUpdated(node.id, {
      ...node.data,
      triggerResource: node.data.performList
    }, null));
  }
  
  dispatch(activeUpdated(!active)); 
  handleScaffoldUpdate(); 
  handleSaveClick();

  if (!active === true && node?.data?.performList) {
    dispatch(createTrigger(1)).then((response)=>{
      if (response.error) {
         dispatch(activeUpdated(!active)); 
         dispatch(notification({ "status": "error", "message": "Error: There was a problem activating the workflow." }))
        
      } else {
        setTriggerMessage(response.payload.triggerMessage)
        saveNode()
        handleSaveClick()

      }
});
  } 
  if (!active === false) {
    dispatch(deleteTrigger(1)).then((response)=>{
      if (response.error) {
         dispatch(activeUpdated(!active)); 
         dispatch(notification({ "status": "error", "message": "Error: There was a problem pausing the workflow." }))
        
      } else {
        setTriggerMessage()
        saveNode()
        handleSaveClick()

      }
});

  }
  !active === true ? dispatch(notification({ "status": "success", "message": "Workflow status: ACTIVE" })): dispatch(notification({ "status": "warning", "message": "Workflow status: PAUSED" }));
  
  // Track workflow activation/deactivation (tag source: 'ai_agent' when this workflow was created via AI agent)
  if (!active === true) {
    let options = {};
    try {
      const lastAiWorkflowId = sessionStorage.getItem('last_ai_workflow_id');
      if (lastAiWorkflowId != null && String(id) === lastAiWorkflowId) {
        options.source = 'ai_agent';
        sessionStorage.removeItem('last_ai_workflow_id');
      }
    } catch (_) {}
    trackWorkflowActivated(id, name, options);
  } else {
    trackWorkflowDeactivated(id, name);
  }
};

  // Activate workflow without validation check (for webhook/form "Test Trigger" listening)
  const handleActivateForListening = () => {
    if (active) return;
    dispatch(activeUpdated(true));
    scaffoldUpdateWithActive(true);
    handleSaveClick();
  };

  // Expose activation for AI agent: when agent calls activate_workflow, flowApp will call requestActivate()
  useEffect(() => {
    if (!activationRequestRef) return;
    activationRequestRef.current = {
      requestActivate: () => {
        if (active_enabled && !active) {
          handleSwitchChange();
        }
      },
      requestActivateForListening: () => {
        if (!active) handleActivateForListening();
      }
    };
    return () => { activationRequestRef.current = null; };
  }, [active_enabled, active, activationRequestRef, handleSwitchChange, handleActivateForListening]);

const handleClickAlert = () => {
  setOpenAlert(true);
};

const handleCloseAlert = (event, reason) => {
  if (reason === 'clickaway') {
      return;
  }
  setOpenAlert(false);
};

const helpClick = () => {
  window.open("https://www.workload.co/help");
  handleHelpClose();
};

const supportClick = () => {
  window.open("https://www.workload.co/docs/get-help/");
  handleHelpClose();
};

const videoClick = () => {
  window.open("https://www.youtube.com/channel/UC_ZGfDbvjlfE0Pi2S7tgFWg/featured");
  handleHelpClose();
};

const [anchorEl, setAnchorEl] = React.useState(null);

  const handleHelpClick = (event) => {
    setAnchorEl(event.currentTarget);
    mixpanel.track('AppBar Help Clicked', {
    });
  };

  const handleHelpClose = () => {
    setAnchorEl(null);
  };
  const [content, setContent] = useState(name);
  const [width, setWidth] = useState(0);
  const [modalopenshare, setModalOpenShare] = useState(false)
  const [modalopensharesuccess, setModalOpenShareSuccess] = useState(false)
  const [modalOpenWorkflowOffWarning, setModalOpenWorkflowOffWarning] = useState(false)
  const [pendingExitAction, setPendingExitAction] = useState(null) // Store the exit function to call after turning on
  const pendingExitActionRef = useRef(null) // Ref so "Leave without turning on" always has latest exit fn (avoids stale closure)
  const leaveWithoutTurningOnInProgressRef = useRef(false) // When true, next popstate should complete navigation without re-opening modal
  const hasPushedHistoryStateRef = useRef(false) // Only push state once so "Leave" doesn't need multiple go(-1)
  const span = useRef();

  useEffect(() => {
    setWidth(span.current.offsetWidth+100);
  }, [content]);

  const handleShareClick = () => {
    mixpanel.track('Share Click', {
      title: name,
      url: 'https://editor.workload.co/?u='+user+'&t='+tenant+'&id='+id
    });
    setModalOpenShare(true)
   
  }

  const handleModalCloseShare = () => {
    setModalOpenShare(false);
};

const handleModalCloseShareSuccess = () => {
  setModalOpenShareSuccess(false);
};

const [sharedtitle, setSharedTitle] = useState()
const [shareddescription, setSharedDescription] = useState()

const handleUndo = () => {
  dispatch({ type: 'UNDO' });
  handleSaveClick()

};
const handleRedo = () => {
  dispatch({ type: 'REDO' });
  handleSaveClick(); // Save after redo like undo does
};

 // Select the workflow loading state from Redux
 const loading = useSelector((state) => state.workflow.present.loading);
  
 // Local state to control cloud icon animation
 const [isSaving, setIsSaving] = useState(false);
 const [tooltipOpen, setTooltipOpen] = useState(false);

 // Watch the Redux loading state for "saving" or "saved" changes.
 useEffect(() => {
   if (loading === 'saving') {
     setIsSaving(true);
   } else if (loading === 'saved') {
     // Stop animation after a delay (e.g., 1s) so the user sees the animation finish
     const timer = setTimeout(() => {
       setIsSaving(false);
     }, 1000);
     return () => clearTimeout(timer);
   }
 }, [loading]);

 useEffect(() => {
  if (loading === 'saving') {
    setTooltipOpen(true);
  } else if (loading === 'saved') {
    // Stop animation after a delay (e.g., 1s) so the user sees the animation finish
    const timer = setTimeout(() => {
      setTooltipOpen(false);
    }, 3000);
    return () => clearTimeout(timer);
  }
}, [loading]);

// Get the undo history from the undoable reducer.
const pastActions = useSelector((state) => state.workflow.past);
// Get the redo history (future actions) from the undoable reducer.
const futureActions = useSelector((state) => state.workflow.future);
// Local state to control the anchor element for the Undo dropdown.

const [anchorElUndo, setAnchorElUndo] = useState(null);

  const body_share = (
    <div style={modalStyle} className={classes.modalshare}>
      <Alert severity="info" style={{ margin: 'auto', justifyContent: 'center', backgroundColor: 'black' }} variant="filled"><Typography style={{fontSize: '18px'}} id="simple-modal-title">Customize your shared workflow template</Typography></Alert><br/><br/>
      <div id='share_container' style={{marginLeft: '10%', marginRight: '10%'}}>
      <AvatarGroup style={{marginBottom: '16px', marginTop: '20px'}} max={20}>
        {iconsfiltered?.map((item) =>
        <Avatar src={item} className={classes.avatarlarge}/>)}
      </AvatarGroup>
      <MuiAlert icon={<LooksOneRoundedIcon fontSize="36px" style={{color: '#0069ea'}}  />} style={{ margin: 'auto', backgroundColor: 'whitesmoke', }} ><Typography style={{fontSize: '18px', color: 'black'}} id="simple-modal-title">Explain what this workflow does.</Typography></MuiAlert><br/><br/>

      <TextField fullWidth  id="workflow_title" variant="outlined" label="Workflow title" defaultValue={name} helperText={"Example of a GREAT title:\n\r\"Get Slack notifications for new Mailchimp subscribers\""} onChange={(e) => setSharedTitle(e.target.value)} /><br /><br />

      <MuiAlert icon={<LooksTwoRoundedIcon fontSize="36px" style={{color: '#0069ea'}} />} style={{ margin: 'auto', backgroundColor: 'whitesmoke', }} ><Typography style={{fontSize: '18px', color: 'black'}} id="simple-modal-title">Describe how it works.</Typography></MuiAlert><br/><br/>

      <TextField multiline={true} minRows={10} rows={10} fullWidth  id="workflow_description" variant="outlined" label="Workflow description" helperText={"Example of a GREAT description:\n\r\"Keep track of your new Mailchimp subscribers in near real-time by setting up this Mailchimp to Slack integration. Once set up, Workload will notify you in Slack every time someone new subscribes to your Mailchimp list.\""} onChange={(e) => setSharedDescription(e.target.value)} /><br /><br />

      {/* <div style={{width:'150px', margin: 'auto', justifyContent: 'center'}} onClick={()=> {handleModalCloseShare();}}><Typography style={{ fontSize: '18px', color: 'black', textAlign: 'center', padding: '25px 15px 15px 15px', cursor: 'pointer', textDecoration: 'underline' }} id="simple-modal-subtitle">Preview</Typography></div> */}
      <Button style={{boxShadow: '2px 2px 5px #303030', display: 'flex', justfiyContent: 'center', alignItems: 'center', padding: '10px', height: '50px', width: '200px', backgroundColor: '#0069ea', borderRadius: '4px', border: 'none', cursor: 'pointer', margin: 'auto' }} onClick={()=> {handleModalCloseShare(); setModalOpenShareSuccess(true)}}><div><Typography style={{ alignText: 'center', fontWeight: 'bold', color: 'white', float: 'left', display: 'block' }}>Share</Typography></div></Button> <br/>
       
        
      </div>
       
        

        
    </div>
);

const body_share_success = (
  <div style={modalStyle} className={classes.modalsharesuccess}>
    <Alert severity="success" style={{ margin: 'auto', justifyContent: 'center' }} variant="filled"><Typography style={{fontSize: '18px'}} id="simple-modal-title">You've shared your workflow template!</Typography></Alert><br/><br/>
    <div id='share_container' style={{marginLeft: '10%', marginRight: '10%'}}>
    
    <MuiAlert icon={<VerifiedUserRoundedIcon fontSize="36px" />} severity="success" style={{ margin: 'auto', backgroundColor: 'whitesmoke', }} ><Typography style={{fontSize: '18px', color: 'dimgray'}} id="simple-modal-title">Sensitive information like account connections, data, and execution logs <strong>are not shared.</strong></Typography></MuiAlert><br/><br/>

    <InputLabel htmlFor="outlined-adornment-password"><Typography variant="h6" style={{ color: 'black' }}><strong>Workflow URL</strong></Typography></InputLabel>
      <FormHelperText id={"descriptionntext"}><Typography variant="body2">Copy this workflow URL and share it with colleagues.</Typography> </FormHelperText>
      <br />
      <OutlinedInput
          disabled
          style={{ width: '100%', color: 'black' }}
          id={'workflow-copy'}
          key={'workflow-copy'}
          label={'workflow URL'}
          defaultValue={'https://editor.workload.co/?template_id='+id}
          helperText={'Copy this URL and share it with colleagues and co-workers.'}
          variant="outlined"
          endAdornment={
              <InputAdornment position="end" className={classes.icon}>
                  <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                          navigator.clipboard.writeText('https://editor.workload.co/?template_id='+id);  mixpanel.track('Share Click - Success', {
                            title: sharedtitle,
                            description: shareddescription,
                            url: 'https://editor.workload.co/?template_id='+id
                          });
                          dispatch(notification({ "status": "info", "message": "Copied to clipboard" }))
                      }}

                      edge="end"
                  >
                      <Divider orientation="vertical" flexItem style={{ marginRight: '8px' }} />
                      <FileCopyOutlinedIcon />

                  </IconButton>
                  <Typography style={{ marginTop: '40px', marginLeft: '-25px' }} variant="caption" display="block" gutterBottom>
                      copy
                  </Typography>
              </InputAdornment>
          }
          labelWidth={70}
      />

    
    
      
    </div>
     
      

      
  </div>
);

  return (
    <div className={classes.root} >
      <AppBar position="fixed" style={{ background: theme.palette.background.paper, zIndex: 99 }}>
        <Toolbar>
        <Tooltip title={<Typography style={{fontSize: '16px'}}>Exit to dashboard</Typography>} placement="top">
          <IconButton onClick={() => closeFrame()} edge="start" className={classes.menuButton} color="default" aria-label="menu">
            <ChevronLeftRoundedIcon />
            <Avatar size={breakpoint !== 'large' ? '20px' : 'large'} style={{marginLeft: breakpoint !== 'large' ? '5px' : '15px',width: breakpoint !== 'large' ? '30px' : null, height: breakpoint !== 'large' ? '30px' : null}} alt="Workload Canvas Editor" src="https://cdn.workload.co/wp-content/uploads/new-logo-only-512-512.png" />
          </IconButton></Tooltip>

          <Tooltip
              title={
                <Typography style={{ fontSize: '10px' }}>
                  {isSaving ? 'Saving changes...' : 'All changes saved'}
                </Typography>
              }
              placement="top"
              open={tooltipOpen}  // force open while saving
            >
            {isSaving ? (
              // Cloud icon without checkmark, pulsing
              
              <CloudOutlinedIcon
                className={classes.pulse}
                style={{ color: theme.palette.text.secondary, fontSize: breakpoint !== 'large' ? '20px' : undefined }}
              />
             
            ) : (
              // Cloud icon with check mark (final state)
              <CloudDoneOutlinedIcon
                style={{ color: theme.palette.text.secondary, fontSize: breakpoint !== 'large' ? '20px' : undefined }}
              />
            )}
          </Tooltip>

          <FormControl className={breakpoint !== 'large' ? classes.marginSmall : classes.margin}>
          <span id="hide" style={{position: 'absolute', opacity: 0, zIndex: -100, whiteSpace: 'pre'}} ref={span}>{content}</span>
            <input
             className={classes.input}
            
              id="input-with-icon-adornment" type="WFName" placeholder="Name your workflow" defaultValue={ name } key={name} onChange={(e) => setContent(e.target.value)} onKeyDown={handleWFSubmitKeyDown} onBlur={(e) => { dispatch(nameUpdated(e.target.value)); handleScaffoldUpdate();setWFName(e.target.value); handleSaveClick(); dispatch(notification({ "status": "success", "message": "Workflow name updated: "+e.target.value }))}} 
              style={{ 
                minWidth: breakpoint !== 'large' ? '150px' : '275px', 
                maxWidth: breakpoint !== 'large' ? '250px' : '450px', 
                width, 
                fontWeight: 700,
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary
              }}
              
            />
           
          </FormControl>
         { breakpoint !== 'large' ? null : <CreateRoundedIcon style={{marginLeft: '-25px',zIndex: 100, color: theme.palette.text.secondary,fontSize: breakpoint !== 'large' ? '20px' : '20px' }} /> }
          <div className={classes.helpSmall}>
          
          <Tooltip title={<Typography style={{fontSize: '16px'}}>Support & documentation</Typography>} placement="top">
          {breakpoint !== 'large' ? <IconButton onClick={handleHelpClick}><HelpOutlineRoundedIcon /></IconButton> : 
          <Button variant='contained' color='primary' style={{textTransform: 'none'}} onClick={handleHelpClick} startIcon={<HelpOutlineRoundedIcon />} >
          Get Help</Button> }</Tooltip>
              <StyledMenu
              id="customized-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleHelpClose}
            >
              <StyledMenuItem onClick={supportClick} >
                <ListItemIcon>
                  <ContactSupportRoundedIcon  />
                </ListItemIcon>
                <ListItemText primary="Help Desk" />
              </StyledMenuItem>
              <StyledMenuItem onClick={helpClick} >
                <ListItemIcon>
                  <MenuBookRoundedIcon  />
                </ListItemIcon>
                <ListItemText primary="Documentation" />
              </StyledMenuItem>
              <StyledMenuItem onClick={videoClick} >
                <ListItemIcon>
                  <OndemandVideoRoundedIcon  />
                </ListItemIcon>
                <ListItemText primary="Video tutorials" />
              </StyledMenuItem>
            </StyledMenu> 
           
          </div>
         {/* UNDO/REDO Buttons */}
<div className={classes.undoRedo}>
  {/* Undo Button + Dropdown Group */}
  <div
   onMouseEnter={(e) => {setAnchorElUndo(e.currentTarget); }}
   onMouseLeave={() => setAnchorElUndo(null)}
    style={{ display: 'inline-block', cursor: 'pointer' }} // keep the group together
  >
    <div>
    {/* <Tooltip title={<Typography style={{ fontSize: '16px' }}>Undo</Typography>}> */}
      <IconButton onClick={handleUndo} disabled={pastActions.length === 0 ? true : false}>
        <UndoIcon />
      </IconButton>
    {/* </Tooltip> */}
    </div>
    {pastActions.length === 0 ? null : 
    <Popper
      id="undo-menu"
      anchorEl={anchorElUndo}
      open={Boolean(anchorElUndo)}
      onClose={() => setAnchorElUndo(null)}
      disableAutoFocus
      disableEnforceFocus
      style={{marginTop: '14px', zIndex: 9999, border: '1px solid', borderColor: theme.palette.type === 'dark' ? '#3E5060' : 'whitesmoke', borderRadius: 8}}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "center",
  }}
  transformOrigin={{
    vertical: "bottom",
    horizontal: "center",
  }}
    >
      {pastActions.slice(-10).reverse().map((past, index) => (
        
          <ListItem key={index}>
            <Typography variant="caption">{`Undo ${past.description}`}</Typography>
          </ListItem>
        
      ))}
    </Popper>
    }
  </div>

  {/* Redo Button */}
  <Tooltip title={<Typography style={{ fontSize: '16px' }}>Redo</Typography>}>
    <IconButton onClick={handleRedo} disabled={futureActions.length === 0 ? true : false}>
      <RedoIcon />
    </IconButton>
  </Tooltip>
</div>
<div className={classes.rightActions}>
         { selectedElement && breakpoint !== 'large' ? null :  <div className={breakpoint !== 'large' ? classes.switchSmall : classes.switch} style={{backgroundColor: active_enabled === false ? 'lightgray' : null }}>
          <Tooltip title={<Typography style={{fontSize: '16px'}}>{active_enabled === false ? (activationBlockerMessage || 'Disabled — finish Setup, Configure, and Test for every step') : !active ? 'Click to activate' : 'Click to deactivate'}</Typography>} placement="bottom">
            <FormControlLabel className={classes.right} style={{ color: theme.palette.text.primary, marginRight: 0 }}
              control={
                <GreenSwitch
                
                  checked={active}
                  name="checkedB"
                  disabled={active_enabled === true ? false : true }
                  onChange={() => handleSwitchChange()}
                />
              }
              label={<Typography style={{ color: theme.palette.text.primary, fontWeight: 'bold' , marginLeft: '10px'}} variant='button' >{!active ? 'OFF' : 'ON'}</Typography>}

            /></Tooltip>
      
          </div> }
          <div className={classes.shareright}>
          <Tooltip title={<Typography style={{fontSize: '16px'}}>{active_enabled === false ? 'Sharing disabled' : 'Share this workflow'}</Typography> }>
            <IconButton aria-label="share" onClick={()=> active_enabled === false ? null : handleShareClick()} >
           
            <ShareRoundedIcon style={{color: active_enabled === false ? 'lightgray' : null}} />
          </IconButton>
          </Tooltip>
          </div>
        </div>
        </Toolbar>
        <Snackbar open={openalert} autoHideDuration={3000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
        <Alert onClose={handleCloseAlert} severity={alert.status}>
            {alert.message}
        </Alert>
    </Snackbar>
    <Modal
      style={{display:'flex',alignItems:'center',justifyContent:'center'}}
          open={modalopenshare}
          onClose={handleModalCloseShare}
          aria-labelledby="simple-modal-title"
          
      >
          {body_share}
      </Modal>

      <Modal
      style={{display:'flex',alignItems:'center',justifyContent:'center'}}
          open={modalopensharesuccess}
          onClose={handleModalCloseShareSuccess}
          aria-labelledby="simple-modal-title"
          
      >
          {body_share_success}
      </Modal>
      <Modal
      style={{display:'flex',alignItems:'center',justifyContent:'center'}}
          open={modalOpenWorkflowOffWarning}
          onClose={handleCancelExit}
          aria-labelledby="workflow-off-warning-title"
      >
        <div style={modalStyle} className={classes.modalsharesuccess}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
            <WarningRoundedIcon style={{ color: '#ff9800', fontSize: '24px', marginRight: '8px' }} />
            <Typography style={{ fontSize: '18px', fontWeight: 600, color: theme.palette.text.primary }} id="workflow-off-warning-title">
              Workflow is not active
            </Typography>
          </div>
          <Typography style={{ fontSize: '16px', color: theme.palette.text.primary, marginBottom: '24px', lineHeight: '1.5' }}>
            Your workflow is ready to be turned on, but it's currently OFF. Turn it on now to start automating?
          </Typography>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '24px' }}>
            <Button 
              variant="text" 
              color="primary"
              style={{ 
                textTransform: 'none', 
                fontSize: '14px',
                padding: '8px 16px',
                whiteSpace: 'nowrap'
              }}
              onClick={handleCancelExit}
            >
              Stay on page
            </Button>
            <Button 
              variant="outlined" 
              color="primary"
              style={{ 
                textTransform: 'none', 
                fontSize: '14px',
                padding: '8px 16px',
                whiteSpace: 'nowrap'
              }}
              onClick={handleLeaveWithoutTurningOn}
            >
              Leave without turning on
            </Button>
            <Button 
              variant="contained" 
              color="primary" 
              style={{ 
                textTransform: 'none', 
                fontSize: '14px',
                padding: '8px 16px',
                whiteSpace: 'nowrap'
              }}
              onClick={handleTurnOnAndExit}
            >
              Turn on workflow
            </Button>
          </div>
        </div>
      </Modal>
      </AppBar>
    </div>
  );
}
